import React from 'react';

const NotMatch = () => {
    return (
        <div>
            <h4>Url Not Found</h4>
            <h1>404</h1>
        </div>
    );
};

export default NotMatch;